export default "__VITE_ASSET__DAMddCsq__"